import React from 'react';
import './aboutUsNumbersSection.scss';
import ScrollCounter from "../../../../components/scrollCounter/ScrollCounter";

const AboutUsNumbersSection = () => {

	return (
		<div className="aboutUsNumbers__container">
			<div className="stars"></div>
			<div className="stars2"></div>
			<div className="stars3"></div>
			<div className="aboutUsNumbers">
				<div className="aboutUsNumbers__title">
					<span>About us in numbers:</span>
				</div>
				<div className="aboutUsNumbers__content">
					<div className="aboutUsNumbers__content_item users">
						<ScrollCounter endNumber={176} time={1500} postfix={'k'} />
						<p>The number of users of all NFD products</p>
					</div>
					<div className="aboutUsNumbers__content_item profit">
						<ScrollCounter endNumber={150} time={1500} prefix={'$'} postfix={'M'} />
						<p>Approximate profit of our users</p>
					</div>
					<div className="aboutUsNumbers__content_item size">
						<ScrollCounter endNumber={108} time={1500} postfix={'k'} />
						<p>The total size of our community</p>
					</div>
				</div>
				<div className="aboutUsNumbers__total">
					<ScrollCounter endNumber={2156589} time={1500} />
					<p>Lines of code in all of our applications</p>
				</div>
			</div>
			<div className="aboutUsNumbers__container_bg_1"></div>
			<div className="aboutUsNumbers__container_bg_2"></div>
		</div>
	);
};

export default AboutUsNumbersSection;